import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import Case from '../../interfaces/case';
import CaseUpdateModal from '../modals/caseUpdateModal';
import RoleManagement from '../../security/roleManagement';
import AuditDataModal from '../modals/auditDataModal';
import JWTTokenPayload from '../../interfaces/JWTTokenPayload';
import { decodedJWT, getOwnerType, getUserRole } from '../../utils/commonUtils';
import AgentAllocationModal from '../modals/agentAllocationModal';
import FocusedCaseAssignmentModal from '../modals/focusedCaseAssignmentModal';
import FocusedCaseUnassignmentModal from '../modals/focusedCaseUnassignmentModal';

interface ReassignmentProps {
    selectedCases: Case[];
}

const GridActions: React.FC<ReassignmentProps> = ({ selectedCases }) => {

    const [updateCase, loadUpdateCase] = useState<boolean>(false);
	const [audit, loadAudit] = useState<boolean>(false);
    const [agentAllocation, loadAgentAllocation] = useState<boolean> (false);
    const [focusedCaseAssignment, setFocusedCaseAssignment] = useState<boolean> (false);
    const [focusedCaseUnassignment, setFocusedCaseUnassignment] = useState<boolean> (false);

	const token: JWTTokenPayload|false  = decodedJWT();

    return (
        <Box display="flex" justifyContent="flex-end" marginY="10px" gap="10px">
            <Button size="medium" variant="outlined" color="primary" onClick={() => loadAudit(true)} style={{
                visibility:selectedCases?.length ===1 ?'visible':'hidden'
            }}>
                <Typography variant="subtitle2">Audit</Typography>
            </Button>
            {RoleManagement.isClient(getOwnerType(token)) && selectedCases?.length > 0 && (
                <Button size="medium" variant="outlined" color="primary" onClick={() => loadUpdateCase(true)}>
                    <Typography variant="subtitle2">Case Update</Typography>
                </Button>   
            )}
            {RoleManagement.isAgency(getOwnerType(token)) && !RoleManagement.isAgent(getUserRole(token)) && selectedCases?.length > 0 && (
                <Button size="medium" variant="outlined" color="primary" onClick={() => loadAgentAllocation(true)}>
                    <Typography variant="subtitle2">Allocate to Agent</Typography>
                </Button>   
            )}
            {!RoleManagement.isAgent(getUserRole(token)) && selectedCases?.length > 0 && (
                <Button size="medium" variant="outlined" color="primary" onClick={() => setFocusedCaseAssignment(true)}>
                    <Typography variant="subtitle2">Focused Case Assignment</Typography>
                </Button>   
            )}
            {!RoleManagement.isAgent(getUserRole(token)) && selectedCases?.length > 0 && (
                <Button size="medium" variant="outlined" color="primary" onClick={() => setFocusedCaseUnassignment(true)}>
                    <Typography variant="subtitle2">Focused Case Unassignment</Typography>
                </Button>   
            )}
            { updateCase && <CaseUpdateModal open={updateCase} selectedRows={selectedCases} onClose={() => loadUpdateCase(false)} />}

            { audit && <AuditDataModal open={audit} selectedRow={selectedCases[0]} onClose={() => loadAudit(false)} />}

            { agentAllocation && <AgentAllocationModal open={agentAllocation} selectedRows={selectedCases} onClose={() => loadAgentAllocation(false) }/> }
            { focusedCaseAssignment && <FocusedCaseAssignmentModal open={focusedCaseAssignment} selectedRows={selectedCases} onClose={() => setFocusedCaseAssignment(false) }/> }
            { focusedCaseUnassignment && <FocusedCaseUnassignmentModal open={focusedCaseUnassignment} selectedRows={selectedCases} onClose={() => setFocusedCaseUnassignment(false) }/> }
        </Box>
    );
}

export default GridActions;